import { GET_NOTIFICATION_DATA } from "./types"

export const notificationDataRequest = data => ({
  type: GET_NOTIFICATION_DATA,
  data
})
